import { render, staticRenderFns } from "./ProductAttributeInput.vue?vue&type=template&id=1a824bba&scoped=true&"
import script from "./ProductAttributeInput.vue?vue&type=script&lang=js&"
export * from "./ProductAttributeInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a824bba",
  null
  
)

export default component.exports